function Footer(){
    return (
        <div id="footer">
            <p>Fleeting Communes</p>
            <p>Developed by Blake Montgomery</p>
        </div>
    )
}

export default Footer;